export default __webpack_public_path__ + "static/thebottomline17-6b6233c692ab18cd92e3c460ae8cb7f2.jpg";